import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

type EmptyStateProps = {
  title: string;
  detail?: string;
  action?: ReactNode;
};

export const EmptyState = ({ title, detail, action }: EmptyStateProps) => (
  <Box sx={{ py: 7, px: 3, textAlign: 'center' }}>
    <InboxOutlinedIcon sx={{ fontSize: 38, color: 'text.disabled', mb: 1 }} />
    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
      {title}
    </Typography>
    {detail ? (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: 460, mx: 'auto' }}>
        {detail}
      </Typography>
    ) : null}
    {action ? <Box sx={{ mt: 2 }}>{action}</Box> : null}
  </Box>
);
